import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.GATSBY_MAIL_BASE_URL,
    headers: { "Content-Type": "application/json;charset=UTF-8" }
});

export default instance;
